export default class InputFieldEvent extends Event {
	/**
	 * The static BLURRED type is dispatched when the InputField is focused and the user tabs out or click somewhere else on the screen.
	 *
	 * Example: addEventListener(InputFieldEvent.BLURRED, (event: InputFieldEvent) => {});
	 */
	public static BLURRED = 'InputFieldEvent.blurred';
	/**
	 * The static CHANGED type is dispatched when the InputField text is changed by the user by typing, clipping or pasting into the InputField.
	 *
	 * Example: addEventListener(InputFieldEvent.CHANGED, (event: InputFieldEvent) => {});
	 */
	public static CHANGED = 'InputFieldEvent.changed';
	/**
	 * The static ENTER type is dispatched when the InputField is focused and the user presses and releases the Enter or Numpad Enter key.
	 *
	 * Example: addEventListener(InputFieldEvent.ENTER, (event: InputFieldEvent) => {});
	 */
	public static ENTER = 'InputFieldEvent.enter';
	/**
	 * The static FOCUSED type is dispatched when the InputField is focused with a Pointer click or being tabbed into.
	 *
	 * Example: addEventListener(InputFieldEvent.FOCUSED, (event: InputFieldEvent) => {});
	 */
	public static FOCUSED = 'InputFieldEvent.focused';
	/** The static HOVERED type is dispatched when the user moves a pointing device over the InputField. */
	public static HOVERED = 'InputFieldEvent.hovered';
	/** The static UN_HOVERED type is dispatched when the user moves a pointing device away from the InputField. */
	public static UN_HOVERED = 'InputFieldEvent.unhovered';
	/** All event types will set the InputField.text property to the current text content of the TextInput. */
	public text: string;
	/**
	 * The InputFieldEvent will be dispatched everytime the user focuses, blurs og change the text content.
	 *
	 * @param type InputFieldEvent.blurred | InputFieldEvent.changed | InputFieldEvent.focused
	 * @param text The current text content of the InputField
	 */
	public constructor(type: string, text: string) {
		assertIsValidType(type);
		assertIsString(text);
		super(type, { bubbles: true });
		this.text = text;
	}
}

function assertIsString(value: unknown): asserts value is string {
	if (typeof value === 'string') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type string`);
}

function assertIsValidType(value: unknown): asserts value is string {
	if (value === InputFieldEvent.BLURRED || value === InputFieldEvent.CHANGED || value === InputFieldEvent.ENTER || value === InputFieldEvent.FOCUSED || value === InputFieldEvent.HOVERED || value === InputFieldEvent.UN_HOVERED) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be BLURRED, CHANGED, ENTER, FOCUSED, HOVERED or UN_HOVERED`);
}
